module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-20.35f208d1.png";